import { takeEvery, call, put } from 'redux-saga/effects'
import { SagaIterator } from 'redux-saga'
import { store } from '../root/index'
import { LoadMediaItemAction, loadedMediaItemFromDisk, removeMediaItemFromDisk, loadMediaItem } from './actions'
import { MediaItemRequestParams, fetchMediaItem, LoadMediaItemFromNetworkResult } from '../api/actions'
import { MediaItem } from 'mytours-read-api-typescript'
import { getConfiguration } from '../configuration'

/**
 * Triggers the loading of a media item
 * @param action contains the id of media item to load
 */
function* handleLoadMediaItem(action: LoadMediaItemAction): SagaIterator {
	const { id, version, language } = action.payload
	const state = store.getState()
	const projectId = state.settings.appInfo.projectId
	const platform = getConfiguration().getPlatform()
	const deviceUUID = getConfiguration().getDeviceUUID()

	const item: MediaItem | undefined = yield call(getConfiguration().loadMediaItemFromDisk, projectId, id, version, language)
	if (item) {
		yield put(loadedMediaItemFromDisk({ id, version, language, mediaItem: item }))
	} else {
		const params: MediaItemRequestParams = {
			devicePlatform: platform,
			deviceUdid: deviceUUID,
			itemId: id,
			itemVersion: version,
			language,
			isPreCaching: false,
		}
		yield put(fetchMediaItem.started(params))
	}
}

/**
 * After a successful request to fetch a mediaitem we want to store the result to disk so that we do not need to hit the network again (unless the item version changes).
 * @param action contains the media item retrieved from network response
 */
function* handleLoadedMediaItemFromNetwork(action: LoadMediaItemFromNetworkResult): SagaIterator {
	const { itemId, itemVersion, language } = action.payload.params
	const item: MediaItem = action.payload.result
	const state = store.getState()
	const projectId = state.settings.appInfo.projectId

	try {
		yield call(getConfiguration().removeMediaItemFromDisk, projectId, itemId, language)
	} catch (error) {
		// Error deleting old data
	}

	try {
		yield call(getConfiguration().saveMediaItemToDisk, projectId, itemId, itemVersion, language, item)
	} catch (error) {
		// Error saving data
	}
}

/**
 * Handles removing a media item from disk
 * @param action contains the id of media item to remove
 */
function* handleRemovingMediaItemFromDisk(action: LoadMediaItemAction): SagaIterator {
	const { id, language } = action.payload
	const state = store.getState()
	const projectId = state.settings.appInfo.projectId

	try {
		yield call(getConfiguration().removeMediaItemFromDisk, projectId, id, language)
	} catch (error) {
		// Error deleting old data
	}
}

export default function*(): SagaIterator {
	yield takeEvery(loadMediaItem, handleLoadMediaItem)
	yield takeEvery(fetchMediaItem.done, handleLoadedMediaItemFromNetwork)
	yield takeEvery(removeMediaItemFromDisk, handleRemovingMediaItemFromDisk)
}
